import request from '@/utils/request';

export function saveOrUpdateCommissionConfig(data) {
  return request({
    url: '/config/saveOrUpdateCommissionConfig',
    method: 'POST',
    data
  });
}
export function fetchCommissionConfigDetail(data) {
  return request({
    url: '/config/fetchCommissionConfigDetail',
    method: 'POST',
    data
  });
}
// 获取一级分销员管理列表
export function queryOneUserCommissionManagePageList(data) {
  return request({
    url: '/user/commission/log/queryOneUserCommissionManagePageList',
    method: 'POST',
    data
  });
}
// 获取分销员推广订单列表
export function queryUserCommissionOrderPageList(data) {
  return request({
    url: '/user/commission/log/queryUserCommissionOrderPageList',
    method: 'POST',
    data
  });
}
// 获取二级分销员管理列表
export function queryTwoUserCommissionManagePageList(data) {
  return request({
    url: '/user/commission/log/queryTwoUserCommissionManagePageList',
    method: 'POST',
    data
  });
}
// 更改分销员-获取要更改的分销员列表
export function queryUserCommissionUserList(data) {
  return request({
    url: '/user/commission/log/queryUserCommissionUserList',
    method: 'POST',
    data
  });
}
// 分销员更改上级
export function updateUserCommission(data) {
  return request({
    url: '/user/commission/log/updateUserCommission',
    method: 'POST',
    data
  });
}
// 下级人员-推广用户
export function queryUserCommissionUserPageList(data) {
  return request({
    url: '/user/commission/log/queryUserCommissionUserPageList',
    method: 'POST',
    data
  });
}
// 佣金设置-获取分销推广者等级列表
export function queryCommissionPromoterLevelPageList(data) {
  return request({
    url: '/commission/promoter/level/queryCommissionPromoterLevelPageList',
    method: 'POST',
    data
  });
}
// 佣金设置-删除分销推广者等级
export function removeCommissionPromoterLevelById(data) {
  return request({
    url: '/commission/promoter/level/removeCommissionPromoterLevelById',
    method: 'POST',
    data
  });
}
// 佣金设置-新增分销推广者等级
export function saveCommissionPromoterLevel(data) {
  return request({
    url: '/commission/promoter/level/saveCommissionPromoterLevel',
    method: 'POST',
    data
  });
}
// 佣金设置-修改分销推广者等级
export function updateCommissionPromoterLevel(data) {
  return request({
    url: '/commission/promoter/level/updateCommissionPromoterLevel',
    method: 'POST',
    data
  });
}
// 佣金设置-修改明细
export function fetchCommissionPromoterLevelDetailById(data) {
  return request({
    url: '/commission/promoter/level/fetchCommissionPromoterLevelDetailById',
    method: 'POST',
    data
  });
}
// 获取所有分销推广者等级列表
export function queryAllCommissionPromoterLevelList(data) {
  return request({
    url: '/commission/promoter/level/queryAllCommissionPromoterLevelList',
    method: 'POST',
    data
  });
}
// 绑定用户分销推广者等级
export function bindUserCommissionPromoterLevel(data) {
  return request({
    url: '/commission/promoter/level/bindUserCommissionPromoterLevel',
    method: 'POST',
    data
  });
}
// 分销报表-获取订单明细列表
export function queryUserCommissionOrderStatisticsPageList(data) {
  return request({
    url: '/user/commission/log/queryUserCommissionOrderStatisticsPageList',
    method: 'POST',
    data
  });
}
// 分销报表-获取一级分销员列表
export function queryFirstUserCommissionUserList(data) {
  return request({
    url: '/user/commission/log/queryFirstUserCommissionUserList',
    method: 'POST',
    data
  });
}
// 分销报表-获取二级分销员列表
export function queryTwoUserCommissionUserList(data) {
  return request({
    url: '/user/commission/log/queryTwoUserCommissionUserList',
    method: 'POST',
    data
  });
}
// 分销报表-头部数据统计
export function queryUserCommissionLogStatistics(data) {
  return request({
    url: '/user/commission/log/queryUserCommissionLogStatistics',
    method: 'POST',
    data
  });
}
// 分销报表-导出Excel
export function exportExcel(data) {
  return request({
    url: '/user/commission/log/exportUserCommissionOrderStatisticsExcel',
    method: 'POST',
    data,
    responseType: 'blob'
  });
}
// 代理申请-列表数据
export function queryCommissionUserApplyLogPageList(data) {
  return request({
    url: '/commission/user/apply/log/queryCommissionUserApplyLogPageList',
    method: 'POST',
    data
  });
}
// 代理申请-申请明细
export function fetchCommissionUserApplyLogDetailById(data) {
  return request({
    url: '/commission/user/apply/log/fetchCommissionUserApplyLogDetailById',
    method: 'POST',
    data
  });
}
// 代理申请-驳回
export function rejectApplication(data) {
  return request({
    url: '/commission/user/apply/log/rejectApplication',
    method: 'POST',
    data
  });
}
// 代理申请-通过
export function approveApplication(data) {
  return request({
    url: '/commission/user/apply/log/approveApplication',
    method: 'POST',
    data
  });
}
// 代理申请-获取一级分销员列表
export function queryFirstCommissionUserList(data) {
  return request({
    url: '/commission/user/apply/log/queryFirstCommissionUserList',
    method: 'POST',
    data
  });
}
// 代理申请-新增或修改代理申请金额门槛配置
export function saveOrUpdateAgentApplyConfig(data) {
  return request({
    url: '/config/saveOrUpdateAgentApplyConfig',
    method: 'POST',
    data
  });
}
// 代理申请-获取代理申请金额门槛配置数据
export function fetchAgentApplyConfigDetail(data) {
  return request({
    url: '/config/fetchAgentApplyConfigDetail',
    method: 'POST',
    data
  });
}
// 代理渠道-获取代理渠道列表
export function queryAgentChannelPageList(data) {
  return request({
    url: '/agent/channel/queryAgentChannelPageList',
    method: 'POST',
    data
  });
}
// 代理渠道-新增代理渠道
export function saveAgentChannel(data) {
  return request({
    url: '/agent/channel/saveAgentChannel',
    method: 'POST',
    data
  });
}
// 代理渠道-修改代理渠道
export function updateAgentChannel(data) {
  return request({
    url: '/agent/channel/updateAgentChannel',
    method: 'POST',
    data
  });
}
// 代理渠道-获取代理渠道明细
export function fetchAgentChannelDetailById(data) {
  return request({
    url: '/agent/channel/fetchAgentChannelDetailById',
    method: 'POST',
    data
  });
}
// 代理渠道-删除代理渠道
export function removeAgentChannelById(data) {
  return request({
    url: '/agent/channel/removeAgentChannelById',
    method: 'POST',
    data
  });
}
// 代理渠道-获取所有代理渠道列表
export function queryAllAgentChannelList(data) {
  return request({
    url: '/agent/channel/queryAllAgentChannelList',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/commission.js